export function ConversionLine() {
  return (
    <div className="flex items-center justify-center my-4 gap-2">
      <div className="flex-1 h-px bg-primary/30" />
      <span className="text-xs text-primary font-medium px-2">Convertido para contato</span>
      <div className="flex-1 h-px bg-primary/30" />
    </div>
  );
}
